import { componentFactory } from '../../../utils/componentFactory';

import styles from './Card.scss';

export const Card = componentFactory<{ onClick?: React.MouseEventHandler<HTMLDivElement> }>({
  name: 'Card',
  classes: styles.card
});
export const CardHeader = componentFactory({ name: 'CardHeader', classes: styles.header });
export const CardContent = componentFactory({ name: 'CardContent', classes: styles.content });
export const CardFooter = componentFactory({ name: 'CardFooter', classes: styles.footer });
